import logo from '../spotify.png';
import Button from 'react-bootstrap/Button';
import classes from './SpotifyLogin.module.css'
import {useEffect, useState} from "react";
import axios from "axios";

function SpotifyLogin({token, setToken, loginDone, setLoginDone}) {

  const CLIENT_ID = process.env.REACT_APP_SPOTIFY_CLIENT_ID
  const REDIRECT_URI = window.location.origin.replace(/\/$/, "")
  const AUTH_ENDPOINT = new URL("https://accounts.spotify.com/authorize")
  const SCOPE = "playlist-read-private playlist-read-collaborative user-read-playback-state user-modify-playback-state streaming user-read-private"

  const [username, setUsername] = useState("")
  const [refreshToken, setRefreshToken] = useState("")
  const [cachedRefreshToken, setCachedRefreshToken] = useState("")
  const [code, setCode] = useState("")
  const [codeVerifier, setCodeVerifier] = useState("")
  const [codeChallenge, setCodeChallenge] = useState("")

  // When cached refresh token is loaded, refresh API token
  useEffect(() => {if (cachedRefreshToken) refresh(cachedRefreshToken)}, [cachedRefreshToken])

  // When code verifier string is created, create code challenge
  useEffect(() => {
    if (!codeVerifier) return
    window.localStorage.setItem('code_verifier', codeVerifier);
    createCodeChallenge(codeVerifier)
  },[codeVerifier])

  // When Spotify auth code is received, get access token for it
  useEffect(() => {
    if (!code) return
    getAccessToken(code)
  },[code])

  // Create code challenge, redirect to Spotify login page
  useEffect(() => {
    if (!codeChallenge) return
    const params =  {
      response_type: 'code',
      client_id: CLIENT_ID,
      scope: SCOPE,
      code_challenge_method: 'S256',
      code_challenge: codeChallenge,
      redirect_uri: REDIRECT_URI,
    }

    AUTH_ENDPOINT.search = new URLSearchParams(params).toString();
    window.location.href = AUTH_ENDPOINT.toString();
  },[codeChallenge])

  // Crypto stuff
  const generateRandomString = (length) => {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const values = crypto.getRandomValues(new Uint8Array(length));
    return values.reduce((acc, x) => acc + possible[x % possible.length], "");
  }

  const createCodeChallenge = (plain) => {
    const encoder = new TextEncoder()
    const data = encoder.encode(plain)
    window.crypto.subtle.digest('SHA-256', data).then(buffer => {
      setCodeChallenge(base64encode(buffer))
    }).catch(e => {console.log("Crypto error: " + e)})
  }

  const base64encode = (input) => {
    return btoa(String.fromCharCode(...new Uint8Array(input)))
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  }

  // Get username for Spotify user when token is set
  useEffect(() => {
    // Get username for logged in user
    if (token) void getUsername()
  }, [token])

  const getUsername = async () => {
    const data = await axios.get("https://api.spotify.com/v1/me", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).catch(function (e) {
      console.log("Failed to get username")
      console.log(e)
      logout()
    })

    if (!data) return
    setUsername(data.data.display_name)
  }

  // Login, logout from Spotify
  const logIn = (e) => {
    e.preventDefault()
    setCodeVerifier(generateRandomString(64))
  }

  const logout = () => {
    console.log("Logout")
    window.localStorage.removeItem("refresh_token")
    setToken("")
  }

  // Functions to get and refresh Spotify tokens
  const getAccessToken = (code) => {
    const url = "https://accounts.spotify.com/api/token"
    axios.post(url, {
      client_id: CLIENT_ID,
      grant_type: 'authorization_code',
      code: code,
      redirect_uri: REDIRECT_URI,
      code_verifier: window.localStorage.getItem('code_verifier'),
    }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(
      data => {
        window.localStorage.setItem('refresh_token', data.data.refresh_token)
        // redirect to home page
        window.location.href = REDIRECT_URI
    }).catch(e => {console.log("Login failedasd"); console.log(e); logout()}).finally(setLoginDone(true))
  }

  const refresh = (refToken) => {
    const url = "https://accounts.spotify.com/api/token"
    axios.post(url, {
      client_id: CLIENT_ID,
      grant_type: 'refresh_token',
      refresh_token: refToken
    }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(
      data => {
        console.log("Refreshed token")
        window.localStorage.setItem('refresh_token', data.data.refresh_token)
        setToken(data.data.access_token)
        setRefreshToken(data.data.refresh_token)
    }).catch(e => {console.log("Refresh failed"); console.log(e); logout()}).finally(setLoginDone(true))
  }

  // When component loads, check for refresh token, log user in...
  useEffect(() => {
    // Check if refresh token exists, start by refreshing token
    const refToken = window.localStorage.getItem("refresh_token")
    if (refToken) {
      setCachedRefreshToken(refToken)
    }
    else {
      // Check if there is a Spotify code in the URL
      const urlParams = new URLSearchParams(window.location.search);
      const c = urlParams.get('code')
      // If so, set code, complete login..
      if (c)
        setCode(c)
      else
        setLoginDone(true)
    }

  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
        refresh(refreshToken)
      }, 600000);
      return () => clearInterval(interval);
    }, [refreshToken]
  );

  return (
    loginDone &&
    <div>
      {token ? (username ?
          <div className={'p-3'}><span className={classes.LogoutText}>Logged in as <span className={"text-muted"}>{username}.</span></span>
            <Button onClick={logout} variant={"outline-secondary"} size="sm">Log out</Button></div> : "") :
        <Button className={classes.SpotifyLoginBtn} variant={'outline-success'} onClick={logIn}>
          <img src={logo} alt={'Spotify logo'}/> Sign in with Spotify
        </Button>}
    </div>
  )
}

export default SpotifyLogin
